import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { LOGIN } from '~/constants/routes';
import { useLanguage } from '~/hooks/language';

export const SuccessView: React.FC = () => {
  const navigate = useNavigate();
  const { translate } = useLanguage('ua');

  const onLoginClick = () => {
    navigate(LOGIN);
  };

  return (
    <Stack spacing={3} alignItems="center">
      <Typography variant="h2" fontWeight={400}>
        {translate('invite.successView.title')}
      </Typography>

      <Typography
        variant="h5"
        textAlign="center"
        fontWeight={400}
        // eslint-disable-next-line react-dom/no-dangerously-set-innerhtml
        dangerouslySetInnerHTML={{
          __html: translate('invite.successView.subtitle'),
        }}
      />

      <Button variant="contained" onClick={onLoginClick} sx={{ minWidth: 200 }}>
        {translate('invite.successView.loginBtnLabel')}
      </Button>
    </Stack>
  );
};
